module.exports = __webpack_public_path__ + "media/images/illustrations/skills-development-02-b1c28cdc2523b4f8971bf7fa8e8db3db.svg";